import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the pathname changes.
 * React Router does NOT do this by default, so category → product navigations
 * inherited the previous page's scroll position.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // "instant" avoids a jarring smooth-scroll animation on every navigation.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
